/* ============================================================
   D2 Layerworks — front-end behaviors
   - Nav scroll state
   - Scroll reveal (IntersectionObserver)
   - Animated counter for stat numbers
   - Bar-chart fill-on-view
   - 3D hover tilt on product cards
   - Hero parallax on floating shapes
   ============================================================ */

(function(){

  /* ---------- NAV scroll state ---------- */
  const nav = document.getElementById('nav');
  if (nav){
    const onScroll = () => {
      if (window.scrollY > 8) nav.classList.add('is-scrolled');
      else nav.classList.remove('is-scrolled');
    };
    document.addEventListener('scroll', onScroll, {passive: true});
    onScroll();
  }

  /* ---------- 3D hover tilt on product cards ---------- */
  function attachTilt(){
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.matchMedia('(hover: none)').matches) return;

    document.querySelectorAll('.product-card:not(.coming)').forEach(card => {
      let rect = null, raf = null;

      card.addEventListener('mouseenter', () => {
        rect = card.getBoundingClientRect();
        card.style.transition = 'transform .15s ease-out, box-shadow .35s ease, border-color .35s ease';
      });
      card.addEventListener('mousemove', (e) => {
        if (!rect) return;
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const x = (e.clientX - rect.left) / rect.width;
          const y = (e.clientY - rect.top) / rect.height;
          const rotY = (x - 0.5) * 8;
          const rotX = (0.5 - y) * 8;
          card.style.transform = `perspective(900px) rotateX(${rotX}deg) rotateY(${rotY}deg) translateY(-4px)`;
          const img = card.querySelector('.pc-img-inner');
          if (img) img.style.transform = `translateX(${(x - 0.5) * 12}px) translateY(${(y - 0.5) * 8}px) scale(1.06)`;
        });
      });
      card.addEventListener('mouseleave', () => {
        rect = null;
        card.style.transition = 'transform .6s cubic-bezier(.2,.7,.2,1), box-shadow .35s ease, border-color .35s ease';
        card.style.transform = '';
        const img = card.querySelector('.pc-img-inner');
        if (img) img.style.transform = '';
      });
    });
  }
  attachTilt();

  /* ---------- Hero parallax ---------- */
  (function heroParallax(){
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const hero = document.querySelector('.hero');
    if (!hero) return;
    const shapes = hero.querySelectorAll('[data-parallax]');
    if (!shapes.length) return;

    let mx = 0, my = 0;
    let scrollY = window.scrollY;
    let ticking = false;

    function update(){
      shapes.forEach(s => {
        const depth = parseFloat(s.dataset.parallax) || 1;
        const tx = mx * 20 * depth;
        const ty = my * 14 * depth - scrollY * 0.08 * depth;
        s.style.transform = `translate3d(${tx}px, ${ty}px, 0)`;
      });
      ticking = false;
    }
    function schedule(){
      if (!ticking){ ticking = true; requestAnimationFrame(update); }
    }
    hero.addEventListener('mousemove', (e) => {
      const rect = hero.getBoundingClientRect();
      mx = (e.clientX - rect.left) / rect.width - 0.5;
      my = (e.clientY - rect.top) / rect.height - 0.5;
      schedule();
    });
    document.addEventListener('scroll', () => {
      scrollY = window.scrollY;
      schedule();
    }, {passive: true});
    update();
  })();

  /* ---------- Animated counter ---------- */
  function animateCount(el){
    const target = parseFloat(el.dataset.count);
    if (!isFinite(target)) return;
    const suffix = el.dataset.suffix || '';
    const isFloat = String(el.dataset.count).includes('.');
    const dur = 1400;
    const start = performance.now();
    function tick(now){
      const t = Math.min(1, (now - start) / dur);
      const eased = 1 - Math.pow(1 - t, 3);
      const v = target * eased;
      const num = isFloat ? v.toFixed(1) : Math.round(v);
      el.innerHTML = num + (suffix ? `<span class="unit">${suffix}</span>` : '');
      if (t < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  /* ---------- Scroll reveal ---------- */
  if ('IntersectionObserver' in window){
    const targets = document.querySelectorAll('.reveal, .product-card');
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting){
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, {threshold: 0.08, rootMargin: '0px 0px -40px 0px'});
    targets.forEach(t => io.observe(t));

    // Counters
    document.querySelectorAll('.num[data-count]').forEach(el => {
      const cio = new IntersectionObserver(entries => {
        entries.forEach(e => {
          if (e.isIntersecting){ animateCount(e.target); cio.unobserve(e.target); }
        });
      }, {threshold: 0.3});
      cio.observe(el);
    });
  } else {
    document.querySelectorAll('.reveal, .product-card').forEach(t => t.classList.add('is-in'));
    document.querySelectorAll('.num[data-count]').forEach(el => {
      el.innerHTML = el.dataset.count + (el.dataset.suffix ? `<span class="unit">${el.dataset.suffix}</span>` : '');
    });
  }

  /* ---------- Sustainability bar fill ---------- */
  const sustainSec = document.getElementById('sustainability');
  if (sustainSec && 'IntersectionObserver' in window){
    const bars = sustainSec.querySelectorAll('.bar-fill');
    bars.forEach(b => { b.dataset.target = b.style.width; b.style.width = '0'; });
    const bio = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting){
          bars.forEach((b, i) => {
            setTimeout(() => { b.style.width = b.dataset.target; }, 200 + i * 180);
          });
          bio.disconnect();
        }
      });
    }, {threshold: 0.3});
    bio.observe(sustainSec);
  }

})();
